import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  name: 'Servicios',
  href: '/servicios'
}, {
  name: 'Proceso',
  href: '/proceso'
}, {
  name: 'Enfoque',
  href: '/resultados'
}, {
  name: 'FAQ',
  href: '/faq'
}, {
  name: 'Contacto',
  href: '/contacto'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/95 backdrop-blur-md transition-[padding] duration-200 ${isScrolled ? 'py-3' : 'py-4'}`} data-id="element-55" data-mp="jm432jgp7vgr">
      <div className="container mx-auto flex items-center justify-between gap-6 px-6 md:px-12" data-id="element-56" data-mp="3n3dsyklhr6z4">
        <Link to="/" className="relative z-50 inline-flex items-center text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label="Growthly, inicio" data-id="element-57" data-mp="3s2gsjpipckzp">
          <span className="text-[13px] font-semibold tracking-[0.16em]" data-id="element-58" data-mp="5oz1avo0pirb">
            GROWTHLY
          </span>
        </Link>

        <nav className="hidden items-center lg:flex" aria-label="Navegación principal" data-id="element-59" data-mp="39bpkqsed52nf">
          <ul className="flex items-center gap-1" data-id="element-60" data-mp="31ahy34gsh0b6">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <li key={link.href} data-id="element-61" data-mp="3b0tevrlkn3zh">
                  <Link to={link.href} aria-current={isActive ? 'page' : undefined} className={`relative block px-3.5 py-2 text-[13px] font-medium tracking-[0.01em] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-300 hover:text-white'}`} data-id="element-62" data-mp="3azrq6kbmuiza">
                    {link.name}
                    {isActive && <motion.span layoutId="nav-indicator" className="absolute inset-x-3.5 -bottom-0.5 h-px bg-white" transition={{
                  type: 'spring',
                  stiffness: 450,
                  damping: 38
                }} data-id="element-63" data-mp="2nbs3bvhfzcpz" />}
                  </Link>
                </li>;
          })}
          </ul>
          <Link to="/checkout" className="ml-5 inline-flex items-center gap-2 bg-white px-4 py-2.5 text-[13px] font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-64" data-mp="1440cvujystb">
            Empezar <ArrowUpRightIcon size={14} aria-hidden="true" data-id="element-65" data-mp="xt1uqcye4opy" />
          </Link>
        </nav>

        <button type="button" className="relative z-50 inline-flex h-10 w-10 items-center justify-center border border-white/20 text-white transition-colors hover:border-white/50 lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-white" onClick={() => setIsMobileMenuOpen(isOpen => !isOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-66" data-mp="k1x3nz9394r8">
          {isMobileMenuOpen ? <XIcon size={19} data-id="element-67" data-mp="3k2kr4n7bzp8n" /> : <MenuIcon size={19} data-id="element-68" data-mp="3k22o97q5ycrr" />}
        </button>
      </div>

      <AnimatePresence data-id="element-69" data-mp="3f3hiytw212wg">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} className="fixed inset-0 z-40 overflow-y-auto overscroll-contain bg-black px-6 pb-12 pt-24 lg:hidden" data-id="element-70" data-mp="3f4138h96g3dn">
            <nav aria-label="Navegación móvil" data-id="element-71" data-mp="3u19wxhlydj8j">
              <ul className="border-t border-white/10" data-id="element-72" data-mp="3u0icn2xt37xk">
                {[{
              name: 'Inicio',
              href: '/'
            }, ...navLinks].map(link => {
              const isActive = location.pathname === link.href;
              return <li key={link.href} className="border-b border-white/10" data-id="element-73" data-mp="2d8d5gyg40yjq">
                      <Link to={link.href} aria-current={isActive ? 'page' : undefined} className={`flex items-center justify-between py-4 text-xl font-medium tracking-tight focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-300'}`} data-id="element-74" data-mp="2dahji97q3dxq">
                        {link.name}
                        <ArrowUpRightIcon size={18} aria-hidden="true" className={isActive ? 'text-white' : 'text-neutral-500'} data-id="element-75" data-mp="30yhc7eolheey" />
                      </Link>
                    </li>;
            })}
              </ul>
            </nav>
            <Link to="/checkout" className="mt-8 flex items-center justify-center gap-2 bg-white px-5 py-4 text-sm font-semibold text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-76" data-mp="3ey9y8wp6f6gl">
              Iniciar mi proyecto{' '}
              <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-77" data-mp="1jubwxggsv8ea" />
            </Link>
            <p className="mt-4 text-center text-xs text-neutral-400" data-id="element-78" data-mp="1xm8j73vseo2r">
              Oferta única · 350€ · Sin cuotas
            </p>
          </motion.div>}
      </AnimatePresence>
    </header>;
}